import "bootstrap/js/dist/collapse";

$(".collapse").collapse({
  toggle: false,
});

function scrollTo(id) {
  $('html, body').animate({
    scrollTop: $(id).offset().top - 150
  }, 1000);
}

$(".accordion__btn").on("click", function (e) {
  const id = $(this).parents(".accordion").attr("id");
  const klikTarget = $(this)[0];
  if (!$(this).hasClass("collapsed")) {
    $(this).children("span").html("+");
    $(this).parent().next().find(".accordion__btn").addClass("collapsed");


    $(this).parent().next().find(".collapse").removeClass("show");
  } else {
    $("#" + id + " .accordion__btn span").html("+");
    $(this).children("span").html("-");
    // console.log(klikTarget.dataset.target);
    setTimeout(function () {
      let dataTarget = document.querySelector(`[data-target='${klikTarget.dataset.target}']`);
      console.log(dataTarget);
      scrollTo(dataTarget);
    }, 200);
  }
});

$(".accordion:not(.accordion--hp)").each(function (i) {
  const children = $(".accordion").eq(i).children();
  const childrenLength = children.length;
  children.each(function (i) {
    if (i < 3) {
      children.eq(i).css("display", "block");
    }
  });
  if (childrenLength > 3) {
    $(".accordion").eq(i).next().css("display", "flex");
  }
});

$("body").on("click", ".accordion__more button", function () {
  if (!$(this).hasClass("active")) {
    $(this).addClass("active");
    $(this)
      .parent()
      .prev(".accordion")
      .children()
      .each(function (i) {
        $(this).css("display", "block");
      });
    $(this).html("zobacz mniej");
  } else {
    $(this).removeClass("active");
    const children = $(this).parent().prev().children();
    children.each(function (i) {
      $(this).css("display", "none");
      if (i < 3) {
        $(this).css("display", "block");
      }
    });
  }
});


// $('.accordion__btn').on('click', function () {
//   const target = $(this).parent().attr('id');
//   setTimeout(function () {
//     scrollTo(target);
//   }, 600);
// });